(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elixi-customer-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elixi-customer-stories')) {
    customElements.define('elixi-customer-stories', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => this.renderStories();
        this.renderStories();
        document.addEventListener('DOMContentLoaded', this.refresh, {once:true});
        document.addEventListener('shopify:section:load', this.refresh);
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.refresh);
        document.removeEventListener('shopify:section:load', this.refresh);
      }
      renderStories() {
        const source = Array.from(document.querySelectorAll('template[data-elixi-story-source]')).find(node => node.dataset.elixiStorySource === this.dataset.productKey);
        if (!source) return;
        this.replaceChildren(source.content.cloneNode(true));
        this.dataset.customerStoriesReady = 'true';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elixi-eye-cream"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeEyeOffers = () => {
    document.querySelectorAll('[data-elixi-eye-product]').forEach((section) => {
      if (section.dataset.eyeOfferInitialized) return;
      section.dataset.eyeOfferInitialized = 'true';
      const form = section.querySelector('.elixi-eye-product__form');
      const variant = section.querySelector('[data-eye-variant]');
      const buttons = section.querySelectorAll('[data-eye-add]');
      const packs = Array.from(section.querySelectorAll('[data-eye-pack]'));
      const bumpInputs = Array.from(section.querySelectorAll('[data-eye-bump]'));
      const error = section.querySelector('[data-eye-error]');
      const currency = new Intl.NumberFormat(section.dataset.locale, {style: 'currency', currency: section.dataset.currency});
      let pending = false;
      section.querySelector('[data-eye-bumps]').hidden = false;
      const validId = (id) => /^\d+$/.test(id || '') && Number.isSafeInteger(Number(id)) && Number(id) > 0;
      const selection = () => {
        const pack = section.querySelector('[data-eye-pack]:checked');
        const bumps = bumpInputs.filter((bump) => bump.checked);
        const available = pack?.dataset.available === 'true' && validId(pack.dataset.variantId) && bumps.every((bump) => bump.dataset.available === 'true' && validId(bump.dataset.variant));
        return {pack, bumps, available};
      };
      const update = () => {
        const {pack, bumps, available} = selection();
        if (!pack) return;
        variant.value = pack.dataset.variantId || '';
        const total = Number(pack.dataset.totalCents) + bumps.reduce((sum, bump) => sum + Number(bump.dataset.price), 0);
        buttons.forEach((button) => {
          button.disabled = pending || !available;
          button.setAttribute('aria-busy', String(pending));
          button.querySelector('[data-eye-button-label]').textContent = pending ? section.dataset.labelPending : available ? button.dataset.labelAvailable : button.dataset.labelUnavailable;
        });
        packs.forEach((packInput) => { packInput.disabled = pending; });
        bumpInputs.forEach((bump) => { bump.disabled = pending || bump.dataset.available !== 'true' || !validId(bump.dataset.variant); });
        section.querySelectorAll('[data-eye-total]').forEach((node) => { node.textContent = currency.format(total / 100); });
        section.querySelectorAll('[data-eye-selected-pack]').forEach((node) => { node.textContent = pack.dataset.packLabel; });
        section.querySelectorAll('[data-eye-shipping]').forEach((node) => { node.textContent = pack.dataset.shipping; });
      };
      form.addEventListener('change', () => { error.hidden = true; update(); });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const {pack, bumps, available} = selection();
        if (pending || !available || !pack) return;
        const items = [{id: Number(pack.dataset.variantId), quantity: 1}, ...bumps.map((bump) => ({id: Number(bump.dataset.variant), quantity: 1}))];
        pending = true;
        error.hidden = true;
        update();
        try {
          const response = await fetch(`${section.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : section.dataset.labelError);
          window.location.assign(section.dataset.cartUrl);
        } catch (problem) {
          error.textContent = problem.message || section.dataset.labelError;
          error.hidden = false;
          pending = false;
          update();
        }
      });
      update();
      const sticky = section.querySelector('[data-eye-sticky]');
      const mainButton = form.querySelector('[data-eye-add]');
      if (sticky && mainButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        });
        observer.observe(mainButton);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeEyeOffers);
  else initializeEyeOffers();
  document.addEventListener('shopify:section:load', initializeEyeOffers);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elixi-product-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elixi-feedback')) {
    customElements.define('elixi-feedback', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-feedback-track]');
        this.controls = this.querySelector('[data-feedback-controls]');
        if (!this.track || !this.controls) return;
        this.previous = this.controls.querySelector('[data-feedback-direction="-1"]');
        this.next = this.controls.querySelector('[data-feedback-direction="1"]');
        this.update = () => {
          if (this.marqueeEnabled) {
            this.controls.hidden = false;
            this.previous.disabled = false;
            this.next.disabled = false;
            return;
          }
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum < 3;
          this.previous.disabled = position < 3;
          this.next.disabled = position >= maximum - 3;
        };
        this.navigate = event => {
          const button = event.target.closest('[data-feedback-direction]');
          if (!button || button.disabled) return;
          const direction = Number(button.dataset.feedbackDirection);
          if (this.marqueeEnabled) { this.nudgeMarquee(direction); return; }
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const card = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({left: direction * rtl * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.controls.addEventListener('click', this.navigate);
        this.track.addEventListener('scroll', this.update, {passive:true});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
        if (this.hasAttribute('data-feedback-autoplay')) {
          if (this.dataset.feedbackAutoplay === 'continuous') this.initializeMarquee();
          else this.initializeAutoplay();
        }
      }
      initializeMarquee() {
        this.marqueeMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.marqueeOriginals = Array.from(this.track.children);
        this.marqueeClones = [];
        this.marqueeListeners = [];
        this.marqueeVisible = false;
        this.marqueeHolding = false;
        this.marqueePaused = false;
        this.marqueePauseUntil = 0;
        this.marqueeCycle = 0;
        const listen = (target, event, handler, options) => {
          target.addEventListener(event, handler, options);
          this.marqueeListeners.push(() => target.removeEventListener(event, handler, options));
        };
        this.stopMarquee = () => {
          cancelAnimationFrame(this.marqueeFrame);
          clearTimeout(this.marqueeResumeTimer);
          this.marqueeLastTime = null;
        };
        this.refreshMarquee = () => {
          this.stopMarquee();
          if (!this.marqueeEnabled || this.marqueeMotion.matches || !this.marqueeVisible || this.marqueeHolding || this.marqueePaused || this.track.matches(':focus-visible') || document.hidden) return;
          const delay = this.marqueePauseUntil - performance.now();
          if (delay > 0) {
            this.marqueeResumeTimer = setTimeout(this.refreshMarquee, delay);
            return;
          }
          this.marqueePosition = Math.abs(this.track.scrollLeft) % this.marqueeCycle;
          this.track.scrollLeft = this.marqueeDirection * this.marqueePosition;
          this.marqueeFrame = requestAnimationFrame(this.stepMarquee);
        };
        this.stepMarquee = time => {
          if (this.marqueeLastTime !== null) {
            const elapsed = Math.min(time - this.marqueeLastTime, 64);
            this.marqueePosition = (this.marqueePosition + elapsed * 0.022) % this.marqueeCycle;
            this.track.scrollLeft = this.marqueeDirection * this.marqueePosition;
          }
          this.marqueeLastTime = time;
          this.marqueeFrame = requestAnimationFrame(this.stepMarquee);
        };
        this.pauseMarquee = () => {
          this.marqueePauseUntil = performance.now() + 1800;
          this.refreshMarquee();
        };
        this.rebuildMarquee = () => {
          this.stopMarquee();
          const oldCycle = this.marqueeCycle;
          const oldPosition = Math.abs(this.track.scrollLeft);
          const progress = oldCycle ? (oldPosition % oldCycle) / oldCycle : 0;
          this.marqueeClones.forEach(clone => clone.remove());
          this.marqueeClones = [];
          this.marqueeEnabled = false;
          this.track.removeAttribute('data-feedback-marquee-track');
          this.marqueeDirection = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.marqueeCycle = 0;
          if (this.marqueeMotion.matches || this.marqueeOriginals.length < 2) {
            this.track.scrollLeft = this.marqueeDirection * Math.min(oldCycle ? oldPosition % oldCycle : oldPosition, Math.max(0, this.track.scrollWidth - this.track.clientWidth));
            this.update();
            return;
          }
          const trackStyle = getComputedStyle(this.track);
          const rows = parseInt(trackStyle.getPropertyValue('--feedback-marquee-rows'), 10) || 1;
          const originalCount = this.marqueeOriginals.length;
          const columnWidth = this.marqueeOriginals[0].getBoundingClientRect().width;
          if (columnWidth <= 0) { this.update(); return; }
          const columnStride = columnWidth + (parseFloat(trackStyle.columnGap) || 0);
          const cycleSets = originalCount % rows ? rows : 1;
          const cycleItems = originalCount * cycleSets;
          const cycleColumns = cycleItems / rows;
          const fillColumns = Math.ceil(this.track.clientWidth / columnStride) + 1;
          const totalSets = Math.max(cycleSets + 1, Math.ceil((cycleColumns + fillColumns) * rows / originalCount));
          this.track.setAttribute('data-feedback-marquee-track', '');
          for (let set = 1; set < totalSets; set++) {
            this.marqueeOriginals.forEach(original => {
              const clone = original.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('data-feedback-clone', '');
              clone.inert = true;
              clone.removeAttribute('id');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
              clone.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
              this.track.append(clone);
              this.marqueeClones.push(clone);
            });
          }
          const nextCycle = this.marqueeClones[cycleItems - originalCount];
          this.marqueeCycle = Math.abs(nextCycle.getBoundingClientRect().left - this.marqueeOriginals[0].getBoundingClientRect().left);
          this.marqueeEnabled = this.marqueeCycle > 0;
          this.track.scrollLeft = this.marqueeDirection * (oldCycle ? progress * this.marqueeCycle : oldPosition % this.marqueeCycle);
          this.update();
          this.refreshMarquee();
        };
        this.nudgeMarquee = direction => {
          this.pauseMarquee();
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = this.marqueeOriginals[0].getBoundingClientRect().width + gap;
          let position = Math.abs(this.track.scrollLeft);
          let target = position + direction * distance;
          if (target < 0) {
            position += this.marqueeCycle;
            target += this.marqueeCycle;
            this.track.scrollLeft = this.marqueeDirection * position;
          }
          this.track.scrollTo({left: this.marqueeDirection * target, behavior: 'smooth'});
        };
        listen(this.track, 'pointerdown', () => {
          this.marqueeHolding = true;
          this.pauseMarquee();
        }, {passive:true});
        const release = () => {
          if (!this.marqueeHolding) return;
          this.marqueeHolding = false;
          this.pauseMarquee();
        };
        listen(document, 'pointerup', release, {passive:true});
        listen(document, 'pointercancel', release, {passive:true});
        listen(this.track, 'wheel', this.pauseMarquee, {passive:true});
        listen(this.track, 'scroll', () => {
          if (this.marqueeHolding || performance.now() < this.marqueePauseUntil) this.pauseMarquee();
        }, {passive:true});
        listen(this, 'focusin', this.refreshMarquee);
        listen(this, 'focusout', () => queueMicrotask(this.refreshMarquee));
        this.track.setAttribute('aria-keyshortcuts', 'Space');
        listen(this.track, 'keydown', event => {
          if (event.code !== 'Space' || event.target !== this.track) return;
          event.preventDefault();
          if (!event.repeat) this.marqueePaused = !this.marqueePaused;
          this.refreshMarquee();
        });
        listen(document, 'visibilitychange', this.refreshMarquee);
        listen(this.marqueeMotion, 'change', this.rebuildMarquee);
        this.marqueeVisibilityObserver = new IntersectionObserver(entries => {
          this.marqueeVisible = entries.some(entry => entry.isIntersecting);
          this.refreshMarquee();
        }, {threshold:0.1});
        this.marqueeVisibilityObserver.observe(this.track);
        this.marqueeResizeObserver = new ResizeObserver(this.rebuildMarquee);
        this.marqueeResizeObserver.observe(this.track);
        this.rebuildMarquee();
      }
      initializeAutoplay() {
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayPaused = false;
        this.autoplayVisible = false;
        this.autoplayHovered = false;
        this.autoplayFocused = this.track.matches(':focus-visible');
        this.autoplayListeners = [];
        const listen = (target, event, handler, options) => {
          target.addEventListener(event, handler, options);
          this.autoplayListeners.push(() => target.removeEventListener(event, handler, options));
        };
        this.scheduleAutoplay = () => {
          clearTimeout(this.autoplayTimer);
          if (this.autoplayPaused || this.motionPreference.matches || !this.autoplayVisible || this.autoplayHovered || this.autoplayFocused || document.hidden || this.track.scrollWidth - this.track.clientWidth < 3) return;
          this.autoplayTimer = setTimeout(() => {
            const maximum = this.track.scrollWidth - this.track.clientWidth;
            const position = Math.abs(this.track.scrollLeft);
            const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
            const card = this.track.firstElementChild;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
            this.track.scrollTo({left: position >= maximum - 3 ? 0 : rtl * Math.min(maximum, position + distance), behavior: 'smooth'});
            this.scheduleAutoplay();
          }, Number(this.dataset.feedbackAutoplay) || 8000);
        };
        listen(this, 'pointerenter', event => {
          if (event.pointerType === 'touch' || this.classList.contains('elixi-feedback--media')) return;
          this.autoplayHovered = true;
          this.scheduleAutoplay();
        });
        listen(this, 'pointerleave', () => {
          this.autoplayHovered = false;
          this.scheduleAutoplay();
        });
        listen(this, 'focusin', () => {
          this.autoplayFocused = this.track.matches(':focus-visible');
          this.scheduleAutoplay();
        });
        listen(this, 'focusout', event => {
          this.autoplayFocused = event.relatedTarget === this.track && this.track.matches(':focus-visible');
          this.scheduleAutoplay();
        });
        listen(this.track, 'pointerdown', () => {
          this.scheduleAutoplay();
        }, {passive:true});
        listen(this.track, 'wheel', () => {
          this.scheduleAutoplay();
        }, {passive:true});
        listen(this.controls, 'click', event => {
          if (event.target.closest('[data-feedback-direction]')) this.scheduleAutoplay();
        });
        this.track.setAttribute('aria-keyshortcuts', 'Space');
        listen(this.track, 'keydown', event => {
          if (event.code !== 'Space' || event.target !== this.track) return;
          event.preventDefault();
          this.autoplayPaused = !this.autoplayPaused;
          this.scheduleAutoplay();
        });
        listen(document, 'visibilitychange', this.scheduleAutoplay);
        listen(this.motionPreference, 'change', this.scheduleAutoplay);
        this.autoplayObserver = new IntersectionObserver(entries => {
          this.autoplayVisible = entries.some(entry => entry.isIntersecting);
          this.scheduleAutoplay();
        }, {threshold:0.15});
        this.autoplayObserver.observe(this.track);
        this.autoplayResizeObserver = new ResizeObserver(this.scheduleAutoplay);
        this.autoplayResizeObserver.observe(this.track);
        this.scheduleAutoplay();
      }
      disconnectedCallback() {
        this.marqueeEnabled = false;
        this.marqueeVisible = false;
        this.stopMarquee?.();
        this.marqueeListeners?.forEach(remove => remove());
        this.marqueeVisibilityObserver?.disconnect();
        this.marqueeResizeObserver?.disconnect();
        this.marqueeClones?.forEach(clone => clone.remove());
        this.track?.removeAttribute('data-feedback-marquee-track');
        clearTimeout(this.autoplayTimer);
        this.autoplayListeners?.forEach(remove => remove());
        this.autoplayObserver?.disconnect();
        this.autoplayResizeObserver?.disconnect();
        if (this.controls && this.navigate) this.controls.removeEventListener('click', this.navigate);
        if (this.track && this.update) this.track.removeEventListener('scroll', this.update);
        if (this.observer) this.observer.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elixi-product-films"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elixi-product-films')) {
    customElements.define('elixi-product-films', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = {signal:this.abortController.signal};
        this.querySelectorAll('.elixi-films__card').forEach(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('[data-film-play]');
          if (!video || !button) return;
          button.hidden = !video.paused;
          button.addEventListener('click', () => {
            video.play().catch(() => { button.hidden = false; });
          }, options);
          video.addEventListener('play', () => {
            button.hidden = true;
            this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          }, options);
          video.addEventListener('pause', () => { button.hidden = false; }, options);
          video.addEventListener('ended', () => { button.hidden = false; }, options);
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elixi-purchase-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elixi-purchase-reviews')) {
    customElements.define('elixi-purchase-reviews', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => this.renderReviews();
        this.renderReviews();
        document.addEventListener('DOMContentLoaded', this.refresh, {once:true});
        document.addEventListener('shopify:section:load', this.refresh);
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.refresh);
        document.removeEventListener('shopify:section:load', this.refresh);
      }
      renderReviews() {
        const source = Array.from(document.querySelectorAll('.elixi-feedback--reviews[data-feedback-product]')).find(node => node.dataset.feedbackProduct === this.dataset.productKey);
        const list = this.querySelector('.elixi-purchase-reviews__list');
        if (!source || !list) return;
        const reviews = Array.from(source.querySelectorAll('.elixi-feedback__review')).slice(0,3);
        if (!reviews.length) {
          this.hidden = true;
          return;
        }
        const cards = reviews.map(review => {
          const card = document.createElement('li');
          card.className = 'elixi-purchase-reviews__card';
          const meta = document.createElement('div');
          meta.className = 'elixi-purchase-reviews__meta';
          const stars = review.querySelector('.elixi-feedback__stars');
          const author = review.querySelector('cite');
          const title = review.querySelector('h3');
          const body = review.querySelector('blockquote p');
          if (stars) meta.append(stars.cloneNode(true));
          if (author) meta.append(author.cloneNode(true));
          card.append(meta);
          if (title) card.append(title.cloneNode(true));
          if (body) card.append(body.cloneNode(true));
          return card;
        });
        list.replaceChildren(...cards);
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elixi-sweet-desire"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeSweetOffers = (scope = document) => {
    scope.querySelectorAll('[data-elixi-sweet-product]').forEach((section) => {
      if (section.dataset.sweetOfferInitialized) return;
      section.dataset.sweetOfferInitialized = 'true';
      const form = section.querySelector('.elixi-sweet-product__form');
      const variant = section.querySelector('[data-sweet-variant]');
      const buttons = [...section.querySelectorAll('[data-sweet-add]')];
      const error = section.querySelector('[data-sweet-error]');
      const sticky = section.querySelector('[data-sweet-sticky]');
      const mainButton = form.querySelector('[data-sweet-add]');
      let pending = false;
      const selected = () => section.querySelector('[data-sweet-pack]:checked');
      const validId = (id) => /^\d+$/.test(id || '') && Number.isSafeInteger(Number(id)) && Number(id) > 0;
      const available = (pack) => pack?.dataset.available === 'true' && validId(pack.dataset.variantId);
      const update = () => {
        const pack = selected();
        if (!pack) return;
        const purchasable = available(pack);
        variant.value = purchasable ? pack.dataset.variantId : '';
        [['[data-sweet-pack-price]', 'price'], ['[data-sweet-unit-price]', 'unitPrice'], ['[data-sweet-total]', 'total'], ['[data-sweet-shipping]', 'shipping'], ['[data-sweet-selected-pack]', 'packLabel']].forEach(([selector, key]) => section.querySelectorAll(selector).forEach((element) => { element.textContent = pack.dataset[key]; }));
        buttons.forEach((button) => {
          button.disabled = pending || !purchasable;
          button.querySelector('[data-sweet-button-label]').textContent = pending ? section.dataset.labelPending : purchasable ? section.dataset.labelAvailable : section.dataset.labelUnavailable;
        });
      };
      form.addEventListener('change', (event) => { if (event.target.matches('[data-sweet-pack]')) { error.hidden = true; update(); } });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const pack = selected();
        if (pending || !available(pack)) return;
        pending = true;
        error.hidden = true;
        form.setAttribute('aria-busy', 'true');
        update();
        try {
          const response = await fetch(`${section.dataset.cartAddUrl}.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(pack.dataset.variantId), quantity: 1}]})});
          if (!response.ok) throw new Error('cart');
          window.location.assign(section.dataset.cartUrl);
        } catch {
          pending = false;
          form.removeAttribute('aria-busy');
          error.textContent = section.dataset.labelError;
          error.hidden = false;
          update();
        }
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0; }, {threshold: 0}).observe(mainButton);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSweetOffers());
  else initializeSweetOffers();
  document.addEventListener('shopify:section:load', (event) => initializeSweetOffers(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
